<template>
  <section
    :key="data.id"
    class="post-description"
  >
    <ArticleContentRender
      v-if="hasBlocks"
      :content="blocks"
      :preloaded-data="preloadedDataWithArticle"
    />
  </section>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { ArticleContentRender } from '@/features/articleContent';
  import type { ArticleContent } from '@/features/articleContent';
  import type { PreloadedData } from '@/features/articleContent/lib/articleComponents';

  interface Props {
    data: {
      id: number;
      blocks?: ArticleContent;
    };
    /** Заголовок статьи для галереи в теле поста */
    articleTitle?: string;
    /** Канонический URL статьи (для ориджина галереи) */
    articleUrl?: string;
  }

  const props = defineProps<Props>();

  const blocks = computed<ArticleContent>(() => (props.data.blocks?.length ? props.data.blocks : []));

  const hasBlocks = computed(() => blocks.value.length > 0);

  const preloadedDataWithArticle = computed<PreloadedData>(() => ({
    linkedArticles: [],
    articlePost:
      props.articleTitle != null && props.data.id != null
        ? { id: props.data.id, title: props.articleTitle, url: props.articleUrl }
        : undefined,
  }));
</script>
